// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.navigation-subpage-select[data-v-1a1b1fa8]{cursor:pointer}.navigation-subpage-select[data-v-1a1b1fa8] .icon-text{transition:filter .2s cubic-bezier(.445,.05,.55,.95);transform:translateZ(0)}.navigation-subpage-select[data-v-1a1b1fa8] .icon-text:hover{filter:brightness(95%)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
